// extracted by mini-css-extract-plugin
export default {"tomato-close":"ButtonTomatoClose_tomato-close__ZuB3W"};